import React from 'react';

const SelectCheckout = () => {
  return (
    <div className="min-vh-100 bg-light d-flex flex-column align-items-center">
      {/* Header */}
      <header className="w-100 bg-white shadow-sm px-4 py-3 d-flex justify-content-between align-items-center">
        <h1 className="h5 fw-semibold text-primary mb-0">
          <span className="text-primary">JOHN LEWIS</span> & PARTNERS
        </h1>
        <span className="text-muted small">Secure checkout 🛒</span>
      </header>

      {/* Main content */}
      <main className="bg-white mt-4 p-4 rounded shadow w-100" style={{ maxWidth: '36rem' }}>
        <h2 className="h4 fw-bold mb-4">Welcome to checkout</h2>

        <div className="d-grid gap-3">
          {/* Sign in option */}
          <div className="border rounded p-3 bg-white" role="button">
            <label className="d-flex align-items-start gap-3 mb-0 cursor-pointer">
              <input type="radio" name="checkout" className="mt-1" />
              <div>
                <p className="fw-medium mb-1">Sign in</p>
                <p className="text-muted small mb-0">
                  Checkout faster with saved details
                </p>
              </div>
            </label>
          </div>

          {/* Guest checkout option */}
          <div className="border rounded p-3 bg-white" role="button">
            <label className="d-flex align-items-start gap-3 mb-0 cursor-pointer">
              <input type="radio" name="checkout" className="mt-1" />
              <div>
                <p className="fw-medium mb-1">Guest checkout</p>
                <p className="text-muted small mb-0">
                  You can create an account once you've completed your order
                </p>
              </div>
            </label>
          </div>
        </div>
      </main>
    </div>
  );
};

export default SelectCheckout;
